export function LoginPage() {
  const apiBase = import.meta.env.VITE_API_URL ?? '/api';
  const loginUrl = `${apiBase}/auth/google`;

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="max-w-md w-full p-8 bg-slate-900 rounded-2xl border border-slate-800">
        <div className="flex items-center gap-3 mb-6">
          <img src="/logo.png" alt="" className="h-10 w-10" />
          <h1 className="text-2xl font-semibold">xLearn Vision</h1>
        </div>
        <p className="text-slate-400 mb-8">
          Generación de imagen, 360, video, audio y avatares con fal.ai.
          Acceso restringido al equipo de xLearning Space.
        </p>
        <a
          href={loginUrl}
          className="block w-full text-center py-3 bg-vision-dark hover:bg-vision text-white rounded-lg font-medium transition-colors"
        >
          Continuar con Google
        </a>
      </div>
    </div>
  );
}
